import { SimpleEventDispatcher } from 'ste-simple-events';

export const materialComplianceDocumentEvents = {
  changed: new SimpleEventDispatcher<number>(),
};
